class ESACustomWidget extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.quantityInputs = this.querySelectorAll('input[name="esa_quantity"]');
    this.purchaseInputs = this.querySelectorAll('input[name="purchase_type"]');

    this.subscribeBox = this.querySelector('.esa__subscribe');
    this.onetimeBox = this.querySelector('.esa__onetime');

    this.sellingPlanInput = this.querySelector('#esa__selling-plan');
    this.quantityInput = this.querySelector('#esa__quantity');

    this.giftItems = this.querySelectorAll('.esa__gift-item');

    this.initEvents();

    const checkedQty = this.querySelector('input[name="esa_quantity"]:checked');
    if (checkedQty) this.updateBundle(checkedQty);

    const checkedPurchase = this.querySelector('input[name="purchase_type"]:checked');
    if (checkedPurchase) this.updateSellingPlan(checkedPurchase);

    this.syncVariantWithBundle();
  }

  initEvents() {
    this.quantityInputs.forEach(input => {
      input.addEventListener('change', e => {
        this.updateBundle(e.target);
      });
    });

    this.purchaseInputs.forEach(input => {
      input.addEventListener('change', e => {
        this.updateSellingPlan(e.target);
      });
    });
  }

  updateBundle(input) {
    const bundleItem = input.closest('.esa__quantity-box')?.querySelector('.esa__bundle-item');
    if (!bundleItem) return;

    const onetimePrice = bundleItem.dataset.priceOnetime;
    const subscriptionPrice = bundleItem.dataset.priceSubscription;
    const comparePrice = bundleItem.dataset.compareSubscription;

    const otPerPack = bundleItem.dataset.perPackOtPrice;
    const subPerPack = bundleItem.dataset.perPackSubPrice;

    const isSubscribe = this.querySelector('input[name="purchase_type"]:checked')?.value === 'subscribe';

    const onetimeEl = this.querySelector('.esa__onetime .esa__bundle-discounted-price');

    const subscribeEl = this.querySelector('.esa__subscribe .esa__bundle-discounted-price');

    const compareEl = this.querySelector('.esa__subscribe .esa__bundle-compare-price');

    if (onetimeEl) onetimeEl.textContent = onetimePrice;
    if (subscribeEl) subscribeEl.textContent = subscriptionPrice;
    if (compareEl) compareEl.textContent = comparePrice;

    const packPriceEl = bundleItem.querySelector('[data-pack-price]');

    if (packPriceEl) {
      packPriceEl.textContent = isSubscribe ? subPerPack : otPerPack;
    }

    const subscriptionMsg = bundleItem.dataset.subscriptionMsg;
    this.querySelector('#esa__subscription-msg').textContent = subscriptionMsg;

    const qty = parseInt(bundleItem.dataset.onetimeQty || 0);
    const sub_qty = parseInt(bundleItem.dataset.subsQty || 0);
    this.updateGifts(qty);
    const checkedPurchase = this.querySelector('input[name="purchase_type"]:checked');
    if (checkedPurchase) this.updateSellingPlan(checkedPurchase);

    if (!isSubscribe) {
      this.quantityInput.value = qty;
    } else {
      this.quantityInput.value = sub_qty;
    }
    
    this.syncVariantWithBundle();
  }

  updateSellingPlan(input) {

    if (!this.sellingPlanInput) return;

    const isSubscribe = input.value === 'subscribe';
    const badge_text = input.dataset.badgeText;

    const freeGiftBox = this.querySelector('.esa__free-gift');
    const memberPricing = this.querySelector('.esa__member-pricing');

    const qty = parseInt(this.querySelector('.esa__quantity-box input:checked')?.closest('.esa__quantity-box')?.querySelector('.esa__bundle-item')?.dataset.onetimeQty || 0);
    const sub_qty = parseInt(this.querySelector('.esa__quantity-box input:checked')?.closest('.esa__quantity-box')?.querySelector('.esa__bundle-item')?.dataset.subsQty || 0);
    const btnText = document.querySelector('.main-atc__label__text');
    const recurringText = document.querySelector('#shopify-buyer-consent');
    
    if (!isSubscribe) {
      freeGiftBox.style.display = '';
      memberPricing.style.display = 'none';
      this.sellingPlanInput.setAttribute('disabled', true);
      this.quantityInput.value = qty;
      setTimeout(() => {
        if (btnText) {
          btnText.textContent = 'Add to cart';
        }
      }, 2200);
      recurringText.style.display = 'none';
    } else {
      freeGiftBox.style.display = 'none';
      memberPricing.style.display = '';
      this.sellingPlanInput.removeAttribute('disabled');
      this.quantityInput.value = sub_qty;
      setTimeout(() => {
        if (btnText) {
          btnText.textContent = 'Start subscription';
        }
      }, 2200);
      recurringText.style.display = 'inline-block';
    }
    
    const planId = this.querySelector('.esa__quantity-box input:checked')?.closest('.esa__quantity-box')?.querySelector('.esa__bundle-item')?.dataset.sellingPlan;
    this.sellingPlanInput.value = planId || '';

    if(badge_text) {
      this.querySelector('.esa__badge').textContent = badge_text;
    }

    this.querySelectorAll('.esa__bundle-item').forEach(item => {
      const packEl = item.querySelector('[data-pack-price]');
      if (!packEl) return;

      packEl.textContent = isSubscribe ? item.dataset.perPackSubPrice : item.dataset.perPackOtPrice;
    });

    this.syncVariantWithBundle();
  }

  updateGifts(qty) {
    this.giftItems.forEach(item => {
      const threshold = parseInt(item.dataset.threshold || 0);
      const img = item.querySelector('img');
      const text = item.querySelector('p');
      if (qty >= threshold) {
        item.classList.add('unlocked');
        if (img && item.dataset.unlockedImg)
          img.src = item.dataset.unlockedImg;
        if (text && item.dataset.unlockText)
          text.textContent = item.dataset.unlockText;
      } else {
        item.classList.remove('unlocked');
        if (img && item.dataset.lockedImg)
          img.src = item.dataset.lockedImg;
        if (text && item.dataset.lockText)
          text.textContent = item.dataset.lockText;
      }
    });
  }

  syncVariantWithBundle() {
    const checkedBundle = this.querySelector('.esa__quantity-box input:checked');
    if (!checkedBundle) return;

    const bundleItem = checkedBundle.closest('.esa__quantity-box')?.querySelector('.esa__bundle-item');

    if (!bundleItem) return;

    const isSubscribe = this.querySelector('input[name="purchase_type"]:checked')?.value === 'subscribe';

    const targetQty = isSubscribe? bundleItem.dataset.subsQty : bundleItem.dataset.onetimeQty;

    if (!targetQty) return;

    const variantRadios = document.querySelectorAll('variant-selects input[type="radio"][name="Package"]');

    variantRadios.forEach(radio => {
      const inputValue = radio.value;
      if (inputValue.includes(`${targetQty} Pack`)) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}

customElements.define('esa-custom-widget', ESACustomWidget);